export default "__VITE_ASSET__b1d6a864__"